<template>
  <div>
    <div class="img">
      <p>{{$t('nav.w42')}}</p>
      <p>Account setting</p>
    </div>
    <div class="security-content">
      <ul class="security_list">
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w20')}}</Col>
            <Col span="14" class="sec">
              <i :class="!userInfo.PassWord && 'message1'" class="message"></i>
              {{userInfo.PassWord ? $t('option.w39') : $t('option.w40')}}
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="showModal('LoginPwd')"
              >{{userInfo.PassWord ? $t('btn.b53') : $t('btn.b54')}}</button>
            </Col>
          </Row>
        </li>
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w21')}}</Col>
            <Col span="14" class="sec">
              <i :class="!userInfo.TransactionPassword && 'message1'" class="message"></i>
              {{userInfo.TransactionPassword ? $t('option.w39') : $t('option.w40')}}
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="showModal('TradePwd')"
              >{{userInfo.TransactionPassword ? $t('btn.b53') : $t('btn.b54')}}</button>
            </Col>
          </Row>
        </li>
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w22')}}</Col>
            <Col span="14" class="sec">
              <i :class="userInfo.Email == '' && 'message1'" class="message"></i>
              {{userInfo.Email !== '' ? userInfo.Email : $t('option.w41')}}
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="showModal('EmailBing')"
              >{{userInfo.Email !== '' ? $t('btn.b55') : $t('btn.b56')}}</button>
            </Col>
          </Row>
        </li>
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w23')}}</Col>
            <Col span="14" class="sec">
              <i :class="userInfo.MobliePhone == '' && 'message1'" class="message"></i>
              <span v-if="userInfo.MobliePhone !== ''">{{userInfo.MobliePhone | phonehide}}</span>
              <span v-else>{{$t('option.w41')}}</span>
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="showModal('PhoneBing')"
              >{{userInfo.MobliePhone !== '' ? $t('btn.b55') : $t('btn.b56')}}</button>
            </Col>
          </Row>
        </li>
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w24')}}</Col>
            <Col span="14" class="sec">
              <template v-if="userInfo.IdCardVerified===0">
                <i class="message message1"></i>
                {{$t('option.w42')}}
              </template>
              <template v-if="userInfo.IdCardVerified===1">
                <i class="message"></i>
                {{$t('option.w17')}}
              </template>
              <template v-if="userInfo.IdCardVerified===2">
                <i class="message message1"></i>
                {{$t('option.w43')}}
              </template>
              <template v-if="userInfo.IdCardVerified===3">
                <i class="message message2"></i>
                {{$t('option.w44')}}
              </template>
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="showModal('VerifiedIDCard')"
                v-if="userInfo.IdCardVerified===0"
              >{{$t('btn.b57')}}</button>
              <button
                class="thr"
                @click="showModal('VerifiedIDCard')"
                v-if="userInfo.IdCardVerified===3"
              >{{$t('btn.b58')}}</button>
            </Col>
          </Row>
        </li>
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w25')}}</Col>
            <Col span="14" class="sec">
              <template v-if="userInfo.BankCardCount===0">
                <i class="message message1"></i>
                {{$t('option.w41')}}
              </template>
              <template v-if="userInfo.BankCardCount>0">
                <i class="message"></i>
                {{$t('option.w45')}}{{userInfo.BankCardCount}}{{$t('option.w46')}}
              </template>
            </Col>
            <Col span="6">
              <router-link :to="{name:'bankCard'}" class="thr">{{$t('btn.b59')}}</router-link>
            </Col>
          </Row>
        </li>
        <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w26')}}</Col>
            <Col span="14" class="sec">
              <i :class="userInfo.DetailAddress == '' && 'message1'" class="message"></i>
              {{userInfo.DetailAddress !== '' ? userInfo.DetailAddress : $t('option.w40')}}
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="showModal('AddressBing')"
              >{{userInfo.DetailAddress !== '' ? $t('btn.b55') : $t('btn.b54')}}</button>
            </Col>
          </Row>
        </li>
        <!-- 滑动验证 -->
        <!-- <li>
          <Row type="flex" justify="center" class="li-content">
            <Col span="4" class="fir">{{$t('label.w221')}}</Col>
            <Col span="14" class="sec">
              <i :class="!userInfo.IsLoginVerif && 'message1'" class="message"></i>
              {{userInfo.IsLoginVerif == true ? $t('label.w222') : $t('label.w223')}}
            </Col>
            <Col span="6">
              <button
                class="thr"
                @click="setLogin(true)"
                v-if="userInfo.IsLoginVerif== true "
              >{{$t('label.w225') }}</button>
              <button class="thr" @click="setLogin(false)" v-else>{{$t('label.w224')}}</button>
            </Col>
          </Row>
        </li>-->
      </ul>
    </div>
    <div class="shield">
      <div class="shield-box">
        <span class="shield-title">
          {{$t('title.w19')}}
          <small>{{$t('msg.m22')}}</small>
        </span>
        <span class="add" @click="showModal('AddShield')">
          <span>{{$t('btn.b51')}}</span>
        </span>
      </div>
      <div class="security-content">
        <Datatable
          url="/Member/RZJProfile/InvestmentScreeManList"
          :th="[]"
          field="InvestmentScreeManList"
          v-slot="{item,refresh}"
          min-height="40px"
          ref="ScreeMan"
          :tip="$t('msg.m122')"
        >
          <tr>
            <td width="15%">
              <b class="gray">{{item.RealName}}</b>
            </td>
            <td>
              <span class="gray">{{item.CreatedAt}} {{$t('option.w47')}}</span>
            </td>
            <td width="25%">
              <a href="javascript:;" @click="shieldCancel(item)">{{$t('btn.b52')}}</a>
            </td>
          </tr>
        </Datatable>
      </div>
      <!-- <div class="security_text" v-if="shieldList&&!shieldList.length">没有屏蔽的名单</div> -->
    </div>

    <EmailBing ref="EmailBing" />
    <LoginPwd ref="LoginPwd" />
    <TradePwd ref="TradePwd" />
    <PhoneBing ref="PhoneBing" />
    <VerifiedIDCard ref="VerifiedIDCard" />
    <AddressBing ref="AddressBing" />
    <AddShield ref="AddShield" @done="shieldRefresh" />
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import LoginPwd from "./modal/loginPwd";
import TradePwd from "./modal/tradePwd";
import EmailBing from "./modal/emailBing";
import PhoneBing from "./modal/phoneBing";
import VerifiedIDCard from "./modal/verifiedIDCard";
import AddressBing from "./modal/addressBing";
import AddShield from "./modal/addShield";
export default {
  name: "securityCenter",
  components: {
    LoginPwd,
    TradePwd,
    EmailBing,
    PhoneBing,
    VerifiedIDCard,
    AddressBing,
    AddShield,
    Datatable
  },
  data() {
    return {
      // userInfo:{},
      modal: false,
      modelTitle: this.$t("title.w20"),
      comName: "LoginPwd"
    };
  },
  methods: {
    showModal(type) {
      this.$refs[type].modal = true;
    },
    shieldRefresh() {
      this.$refs.ScreeMan.refresh();
    },
    shieldCancel(v) {
      this.$axios
        .post("/Member/RZJProfile/DeleteInvestmentScreeMan", { Id: v.Id })
        .then(res => {
          if (res.err) return res.throw();
          this.$Message.success(this.$t("msg.m29"));
          this.shieldRefresh();
        });
    },
    setLogin(v) {
      this.$axios.post("/Member/RZJProfile/UpdateIsLoginVerif").then(res => {
        if (res.err) return res.throw();
        this.$store.dispatch("user/getSafe");
        if (v == true) {
          this.$Message.success(this.$t("msg.m135"));
        } else {
          this.$Message.success(this.$t("msg.m134"));
        }
      });
    }
  },
  created() {},
  computed: {
    userInfo() {
      return this.$store.state.user.safe;
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.img {
  width: 100%;
  height: 199px;
  background: url("../../assets/security/security_bg@2x.png") no-repeat;
  background-size: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  p {
    font-size: 14px;
    font-weight: 500;
    color: #7b7b7c;
  }
  p:first-child {
    font-size: 48px;
    color: #232325;
  }
}
.security-content {
  width: 1200px;
  border-radius: 8px;
  background: #fff;
  .security_text {
    line-height: 30px;
    padding: 15px;
    font-size: 14px;
    text-align: center;
    color: #999;
  }
  .security_list {
    width: 100%;
    height: 100%;
    li {
      width: 1200px;
      border-bottom: 1px solid #f0f1f9;
      .li-content {
        width: 100%;
        height: 81px;
        font-size: 18px;
        color: #232325;
        font-weight: 500;
        align-items: center;
        text-align: center;
        padding-left: 20px;
        .sec {
          text-align: left;
          .message {
            display: inline-block;
            background: url("../../assets/security/public_message.png")
              no-repeat;
            width: 14px;
            height: 14px;
            margin-right: 5px;
            background-position: 0 0;
            background-size: cover;
          }
          .message1 {
            background-position: -14px 0;
          }
          .message2 {
            background-position: -28px 0;
          }
        }
        .thr {
          display: inline-block;
          width: 100px;
          height: 32px;
          border-radius: 16px;
          border: 1px solid rgba(94, 143, 252, 1);
          font-size: 14px;
          color: rgba(94, 143, 252, 1);
          line-height: 32px;
          outline: none;
          background: none;
        }
      }
      .fir {
        text-align: left;
        padding-left: 40px;
        font-weight: bold;
      }
    }
  }
}
.shield {
  padding: 15px 0 50px 0;
  .shield-box {
    height: 50px;
    line-height: 50px;
    .add {
      float: right;
      cursor: pointer;
      font-size: 14px;
      > span {
        display: inline-block;
        vertical-align: middle;
        color: #5e8ffc;
      }
      &:before {
        content: "";
        background: url(../../assets/public_navadd.png);
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .shield-title {
      font-size: 18px;
      font-weight: bold;
      > small {
        font-size: 14px;
        color: #7b7b7c;
        margin-left: 10px;
        font-weight: normal;
      }
    }
    label {
      font-size: 14px;
      margin-left: 25px;
    }
  }
  .shield-li {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #232325;
    font-weight: 500;
    text-align: center;
    padding-left: 20px;
  }
}

.gray {
  color: #7b7b7c;
}
</style>
